<template>
    <u-divider-group class="divider-group--light">
        <li v-for="link in links" :key="link.title">
            <a v-if="link.href" :href="link.href" target="_blank" class="grey--text text--lighten-3">{{ link.title }}</a>
            <router-link v-else :to="link.to" class="grey--text text--lighten-3">{{ link.title }}</router-link>
        </li>
    </u-divider-group>
</template>

<script>
import UDividerGroup from "@/components/publish/styles/groups/u-divider-group.vue";

export default {
    props: {},
    components: {
        UDividerGroup,
    },
    data() {
        return {
            links: [
                // { title: "개인정보처리방침", to: "/privacy-policy" },
                { title: "비급여항목안내", to: "/cost#non-benefit" },
            ],
        };
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
